import { render, staticRenderFns } from "./CaseConfigRelationships.vue?vue&type=template&id=6428ee3e"
import script from "./CaseConfigRelationships.vue?vue&type=script&lang=js"
export * from "./CaseConfigRelationships.vue?vue&type=script&lang=js"
import style0 from "./CaseConfigRelationships.vue?vue&type=style&index=0&id=6428ee3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports